import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../ui/Header';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import FeaturesSection from './components/FeaturesSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const UnifiedLandingHub = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>ScoutBridge - Intelligent Innovation Ecosystem | Corporate-Startup Matching Platform</title>
        <meta 
          name="description" 
          content="Transform your innovation strategy with ScoutBridge's AI-powered startup-corporate matching platform. Connect with 29,200+ verified participants across 85+ countries through intelligent intermediary networks." 
        />
        <meta name="keywords" content="startup matching, corporate innovation, intermediary network, AI matching, innovation platform, startup discovery, corporate partnerships" />
        <meta property="og:title" content="ScoutBridge - Intelligent Innovation Ecosystem" />
        <meta property="og:description" content="The world's most intelligent startup-corporate matching platform with 94.2% success rate." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="ScoutBridge - Intelligent Innovation Ecosystem" />
        <meta name="twitter:description" content="Connect corporations with breakthrough startups through verified intermediary networks." />
        <link rel="canonical" href="/unified-landing-hub" />
      </Helmet>

      {/* Header */}
      <Header />

      {/* Main Content */}
      <main className="pt-16">
        {/* Hero Section */}
        <HeroSection />

        {/* Stats Section */}
        <StatsSection />

        {/* Features Section */}
        <FeaturesSection />

        {/* Testimonials Section */}
        <TestimonialsSection />

        {/* CTA Section */}
        <CTASection />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default UnifiedLandingHub;